import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "row mb-2 pt-2 pb-4" }
const _hoisted_2 = { class: "col-lg-4 col-md-12 text-muted d-flex justify-content-start align-items-center" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 1,
  class: "d-flex align-items-center"
}
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "profile-data" }
const _hoisted_10 = {
  key: 1,
  class: "col-lg-8 input-group"
}
const _hoisted_11 = { class: "d-flex align-items-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("span", null, _toDisplayString(_ctx.labelText) + ": ", 1)
    ]),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.times, (time) => {
        return (_openBlock(), _createElementBlock("div", {
          key: time.id,
          class: "profile-data pb-2"
        }, [
          (!time.edit)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createTextVNode(_toDisplayString(time.start_time ? _ctx.moment(time.start_time,["HH.mm"]).format("h:mm A") : '') + " - " + _toDisplayString(time.end_time ? _ctx.moment(time.end_time,["HH.mm"]).format("h:mm A") : '') + " ", 1),
                (!_ctx.edit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 0,
                      class: "btn btn-link text-primary btn-sm",
                      onClick: ($event: any) => (_ctx.editTime(time))
                    }, _cache[7] || (_cache[7] = [
                      _createElementVNode("i", { class: "fa fa-edit" }, null, -1)
                    ]), 8, _hoisted_4))
                  : _createCommentVNode("", true),
                (!_ctx.edit)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      class: "btn btn-link text-primary btn-sm",
                      onClick: ($event: any) => (_ctx.deleteTime(time.id))
                    }, _cache[8] || (_cache[8] = [
                      _createElementVNode("i", { class: "fa fa-trash" }, null, -1)
                    ]), 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.start_time) = $event)),
                  step: "1800",
                  class: "form-control profile-availability"
                }, null, 512), [
                  [_vModelText, _ctx.start_time]
                ]),
                _cache[11] || (_cache[11] = _createTextVNode("-")),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  step: "1800",
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.end_time) = $event)),
                  class: "form-control profile-availability"
                }, null, 512), [
                  [_vModelText, _ctx.end_time]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: ($event: any) => (_ctx.update(time))
                }, _cache[9] || (_cache[9] = [
                  _createElementVNode("i", { class: "fas fa-save" }, null, -1)
                ]), 8, _hoisted_7),
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: ($event: any) => (_ctx.cancel(time)),
                  type: "button"
                }, _cache[10] || (_cache[10] = [
                  _createElementVNode("i", { class: "fas fa-ban" }, null, -1)
                ]), 8, _hoisted_8)
              ])),
          _createVNode(_component_Loading, {
            active: _ctx.loading,
            "is-full-page": false
          }, null, 8, ["active"])
        ]))
      }), 128)),
      _createElementVNode("div", _hoisted_9, [
        (!_ctx.add)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "btn btn-sm btn-primary mt-3",
              type: "button",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addTime()))
            }, "Add Availability"))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.start_time) = $event)),
                  step: "1800",
                  class: "form-control profile-availability"
                }, null, 512), [
                  [_vModelText, _ctx.start_time]
                ]),
                _cache[14] || (_cache[14] = _createTextVNode("-")),
                _withDirectives(_createElementVNode("input", {
                  type: "time",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.end_time) = $event)),
                  step: "1800",
                  class: "form-control profile-availability"
                }, null, 512), [
                  [_vModelText, _ctx.end_time]
                ]),
                _createElementVNode("button", {
                  class: "btn btn-primary",
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.addTimeSubmit && _ctx.addTimeSubmit(...args)))
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("i", { class: "fas fa-save" }, null, -1)
                ])),
                _createElementVNode("button", {
                  class: "btn btn-secondary",
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.cancelAddTime && _ctx.cancelAddTime(...args))),
                  type: "button"
                }, _cache[13] || (_cache[13] = [
                  _createElementVNode("i", { class: "fas fa-ban" }, null, -1)
                ]))
              ]),
              _createVNode(_component_Loading, {
                active: _ctx.loading,
                "is-full-page": false
              }, null, 8, ["active"])
            ]))
      ])
    ]),
    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "row w-100 m-auto" }, [
      _createElementVNode("div", { class: "col-12 w-75 m-auto" }, [
        _createElementVNode("hr")
      ])
    ], -1))
  ]))
}